// Storefront routes — the URL map of aldoo.com (see PHASE4_WEB_DESIGN.md).
// Wildcards carry the dynamic segments: /book/<pid>[/leave-review],
// /category/<path...>, /author/<slug>[/about] …
import HomePage from "./pages/HomePage"
import CategoryPage from "./pages/CategoryPage"
import ContentTypePage from "./pages/ContentTypePage"
import AuthorPage from "./pages/AuthorPage"
import SellerPage from "./pages/SellerPage"
import CreatorsPage from "./pages/CreatorsPage"
import SignInPage from "./pages/SignInPage"
import SuccessPage from "./pages/SuccessPage"
import BuyProductPage from "./pages/BuyProductPage"
import LicensePage from "./pages/LicensePage"
import UserPage from "./pages/UserPage"
import LibraryPage from "./pages/LibraryPage"
import ContactPage from "./pages/ContactPage"
import TermsPage from "./pages/TermsPage"
import PrivacyPage from "./pages/PrivacyPage"
import ReturnsPage from "./pages/ReturnsPage"
import RefundsPage from "./pages/RefundsPage"
import ProductRoute from "./pages/ProductRoute"
import JoinOrgPage from "./pages/JoinOrgPage"
import VendorArea from "../Vendor"
import { helpCenterRoutes } from "aldoo-ra/HelpCenter/routes"

export default {
  "/": HomePage,
  // Old router served the same catalog page (BookCategoryPage) on /categories and /books
  "/categories": CategoryPage,
  "/books": CategoryPage,
  "/category/*": CategoryPage,
  "/type/*": ContentTypePage,
  // one page for all three: the product's content type picks the layout, the
  // prefix only addresses it (pages/ProductRoute)
  "/book/*": ProductRoute,
  "/album/*": ProductRoute,
  "/product/*": ProductRoute,
  "/creators": CreatorsPage,
  "/authors": CreatorsPage,
  "/author/*": AuthorPage,
  // a seller's page: what they sell, and who they are (/vendor is where sellers work)
  "/seller/*": SellerPage,

  // Commerce, account and landings
  "/success": SuccessPage,
  "/buy-book/*": BuyProductPage,
  "/license": LicensePage,
  "/contact": ContactPage,
  // where an organization invitation mail lands
  "/join-org": JoinOrgPage,
  "/sign-in": SignInPage,
  "/login": SignInPage,
  "/sign-up": SignInPage,
  // the sellers' help center: the same help center as /help-center, its "vendor" articles
  // (aldoo-ra/HelpCenter/context) — before /vendor/*, which would take its paths
  ...helpCenterRoutes("vendor", "/vendor/help-center"),
  // where a vendor works: their orders, sales, products and company
  "/vendor": VendorArea,
  "/vendor/*": VendorArea,
  "/user": UserPage,
  "/user/*": UserPage,
  "/terms-of-use": TermsPage,
  "/returns-policy": ReturnsPage,
  "/refunds-policy": RefundsPage,
  "/privacy-policy": PrivacyPage,
  "/library": LibraryPage,
  "/library/*": LibraryPage,
}
